import TrackInfoIcon from "./TrackInfoIcon";
import { formatDuration, getDisplayTitle } from "./trackUtils";

export default function PlayableTrack({
  track,
  trackId,
  isPlaying,
  isTooltipActive,
  onTrackClick,
  onInfoClick,
  segueInfo,
}) {
  const durationLabel = formatDuration(track.duration_seconds);
  const hasSegue = Boolean(segueInfo?.showArrow);
  const segueTitle = segueInfo?.title || "";
  const isLotterySegue = Boolean(
    segueInfo?.isLottery || track?.segue_type === "lottery_ticket"
  );
  const displayTitle = getDisplayTitle(track);

  return (
    <a
      href="#"
      onClick={(e) => onTrackClick(track, e)}
      className="track-link"
    >
      <span className="track-title-text">
        {displayTitle}
        {hasSegue && (
          <span className="track-segue-arrow" title={segueTitle}>
            &gt;
          </span>
        )}
      </span>
      {durationLabel && (
        <span className="track-duration">{durationLabel}</span>
      )}
      {trackId && (
        <TrackInfoIcon
          trackId={trackId}
          isPlaying={isPlaying}
          isActive={isTooltipActive}
          isLotterySegue={isLotterySegue}
          onInfoClick={onInfoClick}
        />
      )}
    </a>
  );
}
